import moment from 'moment'
import {useState} from 'react'
import {useIntl} from 'react-intl'
import {CrudProvider} from '../../../services/loggedin/CrudContext'
import {ChartsComponent} from '../../parts/crud/Charts'
import {getBaseBarChartOptions} from '../../parts/crud/Types'
import {ServerFilter} from '../../parts/filters/ServerFilter'
import {DataRangeFilter} from '../../parts/filters/DataRangeFilter'
import {EventCategoryFilter} from '../../parts/filters/EventCategoryFilter'
import {Form} from 'react-bootstrap'
import { TimeDimensionGroupFilter } from '../../parts/filters/TimeDimensionGroupFilter'

export const DeviceEventsTrend = () => {
  const intl = useIntl()
  const [loading, setLoading] = useState(false)
  const [filterData, setFilterData] = useState(null)
  const [dateRange, setDateRange] = useState({
    start: moment().subtract(6, 'days'),
    end: moment(),
  })
  const [server, setServer] = useState('all')
  const [groupSelected, setGroupSelected] = useState<any>(null)
  const [serversSelected, setServersSelected] = useState([])
  const [error, setError] = useState('')
  const [eventCategory, setEventCategory] = useState(null)
  const [categorySelected, setCategorySelected] = useState<any>(null)
  const [error_category, setErrorCategory] = useState('')
  const [source_detail, setSourceDetail] = useState('0')
  const [grouping, setGrouping] = useState('day')
  const [groupingOptionSelected, setGroupingOptionSelected] = useState<any>(null)
  const submitData = async () => {
    let has_error = false
    setError('')
    if (
      server === 'oneormore' &&
      (serversSelected === null || (Array.isArray(serversSelected) && serversSelected.length === 0))
    ) {
      setError(intl.formatMessage({id: 'GENERIC.REQUIRED:SELECT_SERVER'}))
      has_error = true
    }
    setErrorCategory('')

    if (
      eventCategory === '0' &&
      (categorySelected === null ||
        (Array.isArray(categorySelected) && categorySelected.length === 0))
    ) {
      setErrorCategory(intl.formatMessage({id: 'GENERIC.REQUIRED:SELECT_CATEGORY'}))
      has_error = true
    }
    if (has_error) {
      return
    }
    setErrorCategory('')
    console.log("categorySelected",categorySelected);
    let data: any = {
      date_range: {
        start: dateRange.start.format('YYYY-MM-DD') + ' 00:00:00',
        end: dateRange.end.format('YYYY-MM-DD') + ' 23:59:59',
      },
      server: server,
      group_list: groupSelected ? groupSelected.value : null,
      selected_server: server === 'oneormore' && serversSelected  ? serversSelected.map((srv: any) => srv.value):[],
      tz: new Date().getTimezoneOffset(),
      event_category: eventCategory,
      selected_category: parseInt(eventCategory+"")===0 && categorySelected ? categorySelected.map((cat: any) => cat.value):[],
      source_detail: source_detail,
      grouping: grouping,
      group_dimension: groupingOptionSelected ? groupingOptionSelected.value : '',
      
    }
    setFilterData(data)
  }
  let params: any = {
    title: intl.formatMessage({id: 'REPORT_DEVICE.DEVICE_TREND.TITLE'}),

    headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
    pointFormat:
      '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
      '<td style="padding:0"><b>{point.y:.0f} </b></td></tr>',
    footerFormat: '</table>',
    shared: true,
    useHTML: true,
  }
  
  let baseChartOptions: any = {...getBaseBarChartOptions(params)}
  baseChartOptions.motion = {}
  baseChartOptions.motion.label = intl.formatMessage({id: 'REPORT_DEVICE.DEVICE_TREND.MOTION_LABEL'})
  baseChartOptions.motion.labels = [];
  baseChartOptions.motion.series = [];
  baseChartOptions.legend = {
    title:{text: intl.formatMessage({id: 'REPORT_DEVICE.DEVICE_TREND.LEGEND_TITLE'})},
    borderWidth: 1,
    layout: 'horizontal',
    backgroundColor: '#FFFFFF',
  
    verticalAlign: 'bottom',
    alignColumns: false,
    
  }
  return (
    <>
      <CrudProvider api='reports/device-trend'>
        <ChartsComponent
          withMotion={true}
          setLoading={(loading) => {
            setLoading(loading)
          }}
          filterData={filterData}
          baseChartOptions={baseChartOptions}
        >
          <p>{intl.formatMessage({id: 'REPORT_DEVICE.DEVICE_TREND.TEXT'})}</p>
          <TimeDimensionGroupFilter
                      onChangedGrouping={(grouping) => {
                        setGrouping(grouping)
                      }}
                      onChangedGroupingOption={(groupingOptionSelected) => {
                        setGroupingOptionSelected(groupingOptionSelected)
                      }}
                    />
          <DataRangeFilter
            onChangedDataRange={(start, end) => {
              setDateRange({
                start: start,
                end: end,
              })
            }}
          />
          <ServerFilter
            onChangedServer={(server) => {
              setServer(server)
            }}
            onChangedServersSelected={(servers) => {
              setServersSelected(servers)
            }}
            onGroupSelected={(group) => {
              setGroupSelected(group)
            }}
          />
          {error && <div className='alert alert-danger'>{error}</div>}
          <EventCategoryFilter
            onChangedEventCategory={(eventCategory: any) => {
              console.log("EventCategory",eventCategory);
              setEventCategory(eventCategory)
            }}
            onChangedCategorySelected={(categorySelected: any) => {
              setCategorySelected(categorySelected)
            }}
          />
          {error_category && <div className='alert alert-danger'>{error_category}</div>}
          <Form.Check
            type='checkbox'
            id='source_detail'
            value='1'
            label={intl.formatMessage({
              id: 'GENERIC.SHOW_DEVICES',
            })}
            checked={source_detail === '1'}
            onChange={(e) => setSourceDetail(e.target.checked ? '1' : '0')}
            className='mb-2'
          />
          <input
            type='button'
            disabled={loading}
            className='btn btn-primary'
            onClick={submitData}
            value={intl.formatMessage({id: 'GENERIC.SUBMIT'})}
            style={{float: 'left'}}
          />{' '}
          {loading && (
            <div
              className='spinner-border text-primary'
              role='status'
              style={{marginTop: '7px', float: 'left', marginLeft: '10px'}}
            >
              <span className='visually-hidden'>Loading...</span>
            </div>
          )}
        </ChartsComponent>
      </CrudProvider>
    </>
  )
}
